export function isUserName(value) {
    if (!value) return true;
    return new RegExp(/^[a-zA-Z ]*$/g).test(value);
}

export function isMobileNumber(value) {
    if (!value) return true;
    return new RegExp(/^[0][6-9]\d{9}$|^[6-9]\d{9}$/g).test(value);
}

export function isAlphabet(value) {
    if (!value) return true;
    return new RegExp(/^[a-zA-Z ]*$/g).test(value);
}

